import { AUTOCOMPLETE_PAPER_SX } from '../constants';

import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material/styles';

type PaperSlot = {
  sx?: SxProps<Theme> | readonly SxProps<Theme>[];
};

/**
 * Merges Forta dropdown `Paper` styles with any caller-provided `componentsProps.paper`.
 */
export function mergeAutocompleteComponentsProps(
  componentsProps: { paper?: PaperSlot } | undefined,
) {
  const paperSx = componentsProps?.paper?.sx;
  const normalizedSx = paperSx == null ? [] : Array.isArray(paperSx) ? [...paperSx] : [paperSx];

  return {
    ...componentsProps,
    paper: {
      ...componentsProps?.paper,
      sx: [AUTOCOMPLETE_PAPER_SX, ...normalizedSx],
    },
  };
}
